import { createElement } from '@syncfusion/ej2-base';
import { isSingleDayEventType } from 'utils/types/learningSchedule';
import {
  isSingleDayAllDayEvent,
  processEventTimesForEdit,
} from '../helpers/helpers';

const generateDetailsSectionElements = (args: any, saveButtonRef: any) => {
  const row = createElement('div', { className: 'details-section' });
  const fRow = createElement('div', { className: 'facilitators-section' });

  const saveButton = args.element.querySelector('.e-event-save');
  if (saveButton instanceof HTMLButtonElement) {
    saveButtonRef.current = saveButton;
  }

  const formElement = args.element.querySelector('.e-schedule-form');

  formElement?.firstChild?.insertBefore(row, formElement.firstChild.firstChild);
  formElement?.firstChild?.insertBefore(fRow, formElement.firstChild.lastChild);

  const detailsContainer = createElement('div', {
    className: 'custom-field-container',
  });
  const facilitatorsContainer = createElement('div', {
    className: 'custom-field-facilitators-container',
  });

  row.appendChild(detailsContainer);
  fRow.appendChild(facilitatorsContainer);

  return {
    row,
    fRow,
    detailsContainer,
    facilitatorsContainer,
  };
};

const processTimesWhenEventTimezonesEnabled = (
  eventTimezones: boolean,
  args: any,
  startTime: string,
  endTime: string,
  isRecurringEvent: boolean
) => {
  if (eventTimezones) {
    const isSingleDayEvent = isSingleDayAllDayEvent(
      args.data as isSingleDayEventType
    );
    const result = processEventTimesForEdit(
      args.data as isSingleDayEventType,
      isSingleDayEvent,
      isRecurringEvent
    );
    startTime = result.startTime;
    endTime = result.endTime;
  }
};

export {
  generateDetailsSectionElements,
  processTimesWhenEventTimezonesEnabled,
};
